export default function canCreateSubUser(props) {

  return props.userList.length + 1 < props.maxUsers;
}
